import { Modal } from "ui/Modal"
import { Button, Flex } from "antd"
import { Text } from "ui/Typography"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

const ExitScheduleTimeOff = ({ open, onCancel, onYes }) => {
  const { t } = useTranslation()

  return (
    <Modal centered title={t("calendar.schedule_time_off.exit")} open={open} onCancel={onCancel} width={430}>
      <Flex vertical gap={spacings.XL}>
        <Text>{t("calendar.schedule_time_off.exit_confirmation")}</Text>
        <Flex gap={spacings.S}>
          <Button variant="outlined" color="primary" onClick={onCancel}>{t("global.cancel")}</Button>
          <Button type="primary" danger onClick={onYes}>{t("global.yes")}</Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

ExitScheduleTimeOff.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onYes: PropTypes.func.isRequired
}

export default ExitScheduleTimeOff
